import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Research from './components/Research';
import Teaching from './components/Teaching';
import Entrepreneurship from './components/Entrepreneurship';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { initScrollIndicator } from './utils/scrollIndicator';
import { Analytics } from '@vercel/analytics/react';
import './App.css';

function App() {
  useEffect(() => {
    initScrollIndicator();
  }, []);

  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={
              <>
                <Hero />
                <Research />
                <Teaching />
                <Entrepreneurship />
                <Contact />
              </>
            } />
            <Route path="/research" element={<Research />} />
            <Route path="/teaching" element={<Teaching />} />
            <Route path="/entrepreneurship" element={<Entrepreneurship />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <Analytics />
      </div>
    </Router>
  );
}

export default App; 